import { GoogleAuthProvider, OAuthProvider } from "firebase/auth";

const providers = {
  google: new GoogleAuthProvider(),
  microsoft: new OAuthProvider("microsoft.com"),
};

export default providers;
